import NavFilterTile from "components/core/blocks/NavFilterTile";
import { setMarketPlace } from "redux/reducers/marketPlace";
import {
  CA,
  US,
  MX,
  BR,
  GB,
  DE,
  NL,
  ES,
  SE,
  PL,
  BE,
  AE,
  SA,
  FR,
  IT,
  IE,
  IN,
  TR,
  AU,
  JP,
  SG,
} from "country-flag-icons/react/3x2";
import { useQuery } from "@tanstack/react-query";
import { getOrgMarketPlacesOptions } from "../../../modules/admin/api/useOrgMarketplaces";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { useSetDefaultMarketplace } from "../../../modules/admin/api/useSetDefaultMarketplace";

function SellerMarketplace({ mobileSidebarItem }: { mobileSidebarItem?: boolean }) {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user);
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  const marketPlacesQuery = useQuery({
    ...getOrgMarketPlacesOptions(user.organization_id),
    select: (data) => Object.keys(data.markets),
  });
  const setDefaultMarketplaceMutation = useSetDefaultMarketplace();

  const onMarketplaceClick = (id: string) => {
    dispatch(setMarketPlace(id));
    localStorage.setItem("Marketplace", id);
    setDefaultMarketplaceMutation.mutate(id);

    if (window.location.href.includes("dsp")) {
      window.location.href = "/user/dsp";
    }
  };

  const items = [
    { header: true as const, label: "North America" },
    {
      value: "CA",
      label: "Canada",
      icon: <CA className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("CA"),
    },
    {
      value: "USA",
      label: "United States",
      icon: <US className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("USA"),
    },
    {
      value: "MX",
      label: "Mexico",
      icon: <MX className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("MX"),
    },
    {
      value: "BR",
      label: "Brazil",
      icon: <BR className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("BR"),
    },
    { header: true as const, label: "Europe" },
    {
      value: "UK",
      label: "United Kingdom",
      icon: <GB className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("UK"),
    },
    {
      value: "DE",
      label: "Germany",
      icon: <DE className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("DE"),
    },
    {
      value: "NL",
      label: "Netherlands",
      icon: <NL className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("NL"),
    },
    {
      value: "ES",
      label: "Spain",
      icon: <ES className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("ES"),
    },
    {
      value: "SE",
      label: "Sweden",
      icon: <SE className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("SE"),
    },
    {
      value: "PL",
      label: "Poland",
      icon: <PL className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("PL"),
    },
    {
      value: "BE",
      label: "Belgium",
      icon: <BE className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("BE"),
    },
    {
      value: "AE",
      label: "UAE",
      icon: <AE className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("AE"),
    },
    {
      value: "SA",
      label: "Saudi Arabia",
      icon: <SA className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("SA"),
    },
    {
      value: "FR",
      label: "France",
      icon: <FR className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("FR"),
    },
    {
      value: "IT",
      label: "Italy",
      icon: <IT className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("IT"),
    },
    {
      value: "IE",
      label: "Ireland",
      icon: <IE className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("IE"),
    },
    {
      value: "IN",
      label: "India",
      icon: <IN className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("IN"),
    },
    {
      value: "TR",
      label: "Turkey",
      icon: <TR className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("TR"),
    },
    { header: true as const, label: "Far East" },
    {
      value: "AU",
      label: "Australia",
      icon: <AU className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("AU"),
    },
    {
      value: "JP",
      label: "Japan",
      icon: <JP className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("JP"),
    },
    {
      value: "SG",
      label: "Singapore",
      icon: <SG className="flag-icon" />,
      isDisabled: !marketPlacesQuery.data?.includes("SG"),
    },
  ];

  return (
    <NavFilterTile
      items={items}
      mobileSidebarItem={mobileSidebarItem}
      selectedKey={marketPlace}
      onSelectionChange={onMarketplaceClick}
    />
  );
}

export default SellerMarketplace;
